import React, { createContext, useContext, useEffect, useState } from 'react';
import { CUSTOM_EVENTS } from '../../../../../utils/constants';
import PropTypes from 'prop-types';

const AppointmentContext = createContext(null);

const AppointmentProvider = ({ children }) => {
    const [selectedAppointment, setSelectedAppointment] = useState(null);

    useEffect(() => {
        const updateAppointment = (e) => {
            const data = e.detail;
            setSelectedAppointment(data);
        };

        document.addEventListener(CUSTOM_EVENTS.UPDATE_SELECTED_APPOINTMENT, updateAppointment);
        return () => {
            document.removeEventListener(CUSTOM_EVENTS.UPDATE_SELECTED_APPOINTMENT, updateAppointment);
        };
    }, []);

    return (
    <AppointmentContext.Provider value={{ appointment: selectedAppointment }}>
        {children}
    </AppointmentContext.Provider>
    );
};

export const useAppointmentContext = () => {
  const context = useContext(AppointmentContext);
  if (!context) {
    throw new Error('useAppointmentContext must be used within AppointmentProvider');
  }
  return context;
};

export default AppointmentProvider;

AppointmentProvider.propTypes = {
    children: PropTypes.node.isRequired
};